import { faChevronLeft, faChevronRight } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Typography, useMediaQuery } from "@mui/material";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { sxLabel, sxSubTitle } from "../../../../assets/styles/CommonSxProps";
import DefaultButton from "../../../../components/Accessibility/DefaultButton";
import TypographyAccessibility from "../../../../components/Accessibility/TypographyAccessibility";
import VoltarButton from "../../../../components/Accessibility/VoltarButton";
import WhiteContainer from "../../../../components/Accessibility/WhiteContainer";
import Calendar from "../../../../components/Calendar/Calendar";
import { HoursForm } from "../../../../components/HoursForm";
import LoadingApp from "../../../../components/LoadingApp";
import { Horario } from "../../../../interfaces/entities/SaudeBemEstar/Agendamento/Horario";
import { StepProps } from "../../../../interfaces/entities/SaudeBemEstar/GestaoDeCronicos/StepProps";
import { IHorarioDisponivel } from "../../../../interfaces/entities/SaudeBemEstar/PrimeiroAgendamento/HorarioDisponivel";
import { getHorariosDisponiveisPeriodoGestao } from "../../../../services/SaudeBemEstar/GestaoDeCronicosService";
import { useAccessibility } from "../../../../Store/contexts/AccessibilityContext";
import PrestadorCard from "./PrestadorCard";
import './styles.css';
import { sxBoxChevron } from "./sxProps";

const StepHorario: React.FC<StepProps> = ({ backStep, onProceedHorario, openModalError, doctor, tipoAtend }) => {

  const accessibility = useAccessibility();
  const [loading, setLoading] = useState<boolean>(false);

  const [availableDates, setAvailableDates] = useState<Horario[]>([]);
  const [availableTimes, setAvailableTimes] = useState<IHorarioDisponivel[]>([]);
  const [selectedTime, setSelectedTime] = useState<IHorarioDisponivel | null>(null);
  const [selectedDate, setSelectedDate] = useState<Date | null>(null);
  const isMobile = useMediaQuery("(max-width: 1400px)");

  useEffect(() => {
    fetchDateOptions();
  }, []);

  const fetchDateOptions = async () => {
    setLoading(true);
    const start = dayjs().month(new Date().getMonth()).startOf('month').toDate();
    const end = dayjs().month(new Date().getMonth()).endOf('month').toDate();
    const response = await getHorariosDisponiveisPeriodoGestao(doctor!, start, end, tipoAtend!);
    if (response?.status === 200) {
      setAvailableDates(response.data);
      setAvailableTimes(response.data);
    } else {
      console.error(response);
      openModalError('Erro', 'Ocorreu um erro ao consultar as opções de agendamento.');
    }
    setLoading(false);
  }

  const handleSelectedDate = (date: Date) => {
    setSelectedDate(date);
  };

  const handleHour = (hour: IHorarioDisponivel) => {
    setSelectedTime(hour);
  }

  const handleSelectedMonth = (date: Date) => {
    setLoading(true)
    const month = date.getMonth();
    const start = dayjs().month(month).startOf('month').toDate();
    const end = dayjs().month(month).endOf('month').toDate();

    getHorariosDisponiveisPeriodoGestao(doctor!, start, end, tipoAtend!).then((result) => {
      setAvailableDates(result?.data);
      setAvailableTimes(result?.data);
    }).finally(() => setLoading(false))
  };

  const handleProceed = () => {
    if (selectedTime) {
      onProceedHorario!(selectedTime);
    } else {
      openModalError('Erro', 'Selecione um horário para prosseguir.');
    }
  }

  return (
    <>
      <LoadingApp showLoading={loading} text={'Carregando...'} />
      <div className='feature-container'>
        <Typography sx={sxSubTitle} component={'h2'} style={{color: '#383838'}}>Data e horário</Typography>
        <PrestadorCard
          prestador={doctor}
          showTitle
          button={
            <div className='flex-row'>
              <button className="editar-contato-button"
                onClick={backStep}
                style={accessibility.textStyleAccessibility}
                aria-label={`trocar profissional ${doctor?.nome}`}
              >
                <FontAwesomeIcon icon={faChevronLeft} color="#00834F" style={{...accessibility.textStyleAccessibility, marginRight: '5px'}} />
                Trocar profissional
              </button>
            </div>
          }
        />
        <div className="calendar-hours-holder">
          <div>
            <TypographyAccessibility sx={sxLabel} marginBottom={'12px'} component={'h2'}>
              Selecione uma data no calendário
            </TypographyAccessibility>
            <Calendar
              handleDate={handleSelectedDate}
              handleMonth={handleSelectedMonth}
              daysList={availableDates.map((time) => time.data)}
              selectedDate={selectedDate} />
          </div>
          {
            selectedDate !== null &&
            <>
              {!isMobile &&
                <div className="content-chevron">
                  <WhiteContainer shadow sx={sxBoxChevron}>
                    <FontAwesomeIcon icon={faChevronRight} />
                    <FontAwesomeIcon icon={faChevronRight} />
                  </WhiteContainer>
                </div>
              }
              <div className="content-hours">
                <HoursForm
                  selectedDate={selectedDate}
                  handleHour={handleHour}
                  selectedHour={selectedTime}
                  hoursList={availableTimes} />
              </div>
            </>
          }
        </div>
        <DefaultButton text='Continuar' onClick={handleProceed} disabled={!selectedTime} />
        <VoltarButton onClick={backStep} />
      </div>
    </>
  )
}

export default StepHorario;